import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { previewBadge } from "../styles/styles";
import CustomTooltipBox from "../../../Components/CustomTooltips/CustomTooltipBox";

export default function TopAppBar({
  isBelowMd,
  toggleDrawer,
  pageTitle,
  currentItem,
}) {
  const { t } = useTranslation("bottom-menu-and-settings", "tooltip-sections");

  return (
    <AppBar
      position={"fixed"}
      sx={{
        width: "100%",
        display: isBelowMd ? "flex" : "none",
        bgcolor: isBelowMd ? "#fff" : "transparent",
        borderBottom: !isBelowMd ? "none" : "1px solid #eaeaea",
        boxShadow: "none",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          padding: "13px 16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: "8px",
          }}
        >
          <IconButton onClick={toggleDrawer} edge="start">
            <img src="/icons/sidebar-icons/menu-icon.svg" alt="menu" />
          </IconButton>
          {pageTitle && (
            <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                fontSize: "18px",
                fontWeight: 500,
                color: "rgba(47, 43, 61, 1)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {pageTitle}

              {currentItem?.preview && (
                <Box component="span" sx={previewBadge}>
                  {t("preview_only")}
                </Box>
              )}
            </Typography>
          )}

          {currentItem?.showTooltip && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CustomTooltipBox
                sections={t(currentItem.id, {
                  returnObjects: true,
                  ns: "tooltip-sections",
                })}
              />
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
